export * from '@primeuix/themes/nora/carousel';
export { default } from '@primeuix/themes/nora/carousel';
